import axios from 'axios';
import { Platform } from 'react-native';

import responseCodes from '../constants/responseCodes';
import { notification } from '../helperFunctions';

import apiUrl from './apiServer';
export const apiSeverUrl = apiUrl;

axios.defaults.withCredentials = true;

const baseService = axios.create({
  baseURL: `${apiSeverUrl}/api/v10`,
  headers: { 'from-web-app': Platform.OS == 'web' },
});

baseService.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error instanceof Error ? error : new Error(error));
  }
);

baseService.interceptors.response.use(
  (response) => {
    if (response.data.response_code === responseCodes.OK) {
      if (
        response.data.message === 'Referral sent successfully' ||
        response.data.message === 'Waiting for strengthening questions to be answered' ||
        response.data.message === 'Email Sent! Please check your inbox for an email from Boon with your magic link'
      )
        return response;
      if (response.data.message) {
        notification.ref.show({ message: response.data.message, isError: false });
      }
      return response;
    } else {
      const isError =
        response.data.response_code &&
        response.data.response_code !== responseCodes.ACCOUNT_IS_NOT_CONFIRMED &&
        response.data.response_code !== responseCodes.PHONE_NUMBER_REQUIRED;
      if (
        response.data.error === 'Pdf You are not allowed to upload "png" files, allowed types: pdf, Pdf can\'t be blank'
      ) {
        response.data.error = 'Pdf file allowed only; Pdf cannot be blank';
      }
      return response;
    }
  },
  (error) => {
    if (error.response.status === responseCodes.TOO_MANY_REQUESTS) {
      notification.ref.show({ message: 'Too many requests. Please try again after some time.', isError: true });
    }
    return Promise.reject(error);
  }
);

export default baseService;
